import { useState, useEffect } from 'react'
import { isDesktop, getDesktopPlatform } from '@/lib/platform'
import { WindowControls } from './WindowControls'
import { UpdateIndicator } from './UpdateIndicator'

export function DesktopTitleBar() {
  const [maximized, setMaximized] = useState(false)
  const platform = getDesktopPlatform()

  useEffect(() => {
    if (!isDesktop()) return

    window.ledgerDesktop.windowControls.isMaximized().then(setMaximized)
    const unsub = window.ledgerDesktop.windowControls.onMaximizeChange(setMaximized)
    return unsub
  }, [])

  if (!isDesktop()) return null

  return (
    <div
      className="flex h-[38px] w-full shrink-0 items-center bg-slate-900 select-none"
      style={{ WebkitAppRegion: 'drag' } as React.CSSProperties}
    >
      {/* macOS: spacer for native traffic lights */}
      {platform === 'darwin' && <div className="w-[70px] shrink-0" />}

      {/* Windows: app icon + title */}
      {platform === 'win32' && (
        <div className="flex items-center gap-2 pl-3">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#6366f1"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z" />
            <path d="M8 10h8" />
            <path d="M8 14h4" />
          </svg>
          <span className="text-xs font-medium text-slate-400">Ledger</span>
        </div>
      )}

      {/* macOS: centered title */}
      {platform === 'darwin' && (
        <span className="text-xs font-medium text-slate-400">Ledger</span>
      )}

      <div className="flex-1" />

      {/* Update indicator */}
      <div style={{ WebkitAppRegion: 'no-drag' } as React.CSSProperties}>
        <UpdateIndicator />
      </div>

      {/* Windows: window controls */}
      {platform === 'win32' && (
        <div style={{ WebkitAppRegion: 'no-drag' } as React.CSSProperties}>
          <WindowControls maximized={maximized} />
        </div>
      )}
    </div>
  )
}
